import { render, staticRenderFns } from "./chartMult2.vue?vue&type=template&id=dd811ef2&"
import script from "./chartMult2.vue?vue&type=script&lang=js&"
export * from "./chartMult2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports